(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trip-detail"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function openDetail(slug) {
      var modal = document.getElementById('zd-trip-detail-' + slug);
      if (!modal) return;
      modal.removeAttribute('hidden');
      modal.removeAttribute('aria-hidden');
      if (window.ZDScrollLock) window.ZDScrollLock.lock();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          modal.classList.add('is-open');
          modal.scrollTop = 0;
          var panel = modal.querySelector('.zd-detail__panel');
          if (panel) panel.scrollTop = 0;
          var closeBtn = modal.querySelector('.zd-detail__close');
          if (closeBtn) closeBtn.focus();
        });
      });
    }

    function closeDetail(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      if (window.ZDScrollLock) window.ZDScrollLock.unlock();
      modal.addEventListener('transitionend', function onEnd(e) {
        if (e.target !== modal.querySelector('.zd-detail__panel')) return;
        modal.setAttribute('hidden', '');
        modal.removeEventListener('transitionend', onEnd);
      });
    }

    document.addEventListener('click', function(e) {
      var opener = e.target.closest('[data-open-detail]');
      if (opener) {
        var slug = opener.getAttribute('data-open-detail');
        if (slug) openDetail(slug);
        return;
      }
      var closer = e.target.closest('[data-zd-detail-close]');
      if (closer) {
        closeDetail(closer.closest('.zd-detail'));
        return;
      }
    });

    document.addEventListener('keydown', function(e) {
      var opener = e.target.closest('[data-open-detail]');
      if (opener && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        opener.click();
        return;
      }
      if (e.key === 'Escape') {
        var open = document.querySelector('.zd-detail.is-open');
        if (open) closeDetail(open);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trips-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {

    /* =====================================================
       TRIPS MODAL – abrir / cerrar
       ===================================================== */
    function openTripsModal() {
      var modal = document.getElementById('zd-trips-modal');
      if (!modal) return;
      modal.removeAttribute('hidden');
      modal.removeAttribute('aria-hidden');
      if (window.ZDScrollLock) window.ZDScrollLock.lock();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          modal.classList.add('is-open');
          var closeBtn = document.getElementById('zd-tmodal-close');
          if (closeBtn) closeBtn.focus();
        });
      });
    }

    function closeTripsModal() {
      var modal = document.getElementById('zd-trips-modal');
      if (!modal) return;
      modal.classList.remove('is-open');
      if (window.ZDScrollLock) window.ZDScrollLock.unlock();
      modal.addEventListener('transitionend', function onEnd(e) {
        if (e.target !== modal.querySelector('.zd-tmodal__panel')) return;
        modal.setAttribute('hidden', '');
        modal.removeEventListener('transitionend', onEnd);
      });
    }

    /* =====================================================
       TRIP DETAIL – abrir con carga desde index.trips
       (Section Rendering API: fuente única de verdad)
       ===================================================== */

    /**
     * Abre el panel de detalle de un viaje.
     * Si el HTML ya está en el DOM (estamos en /?view=trips), lo usa directamente.
     * Si no (estamos en la home /), lo carga via Section Rendering API desde
     * el template index.trips, que es donde están los datos reales y actualizados.
     */
    function openDetail(slug) {
      var panelId = 'zd-trip-detail-' + slug;
      var existing = document.getElementById(panelId);

      if (existing) {
        // Ya está en el DOM → abrir directamente
        _showDetailPanel(existing);
      } else {
        // No está en el DOM → cargar desde index.trips via Section Rendering API
        var sectionKey = 'trip_detail_' + slug;
        var url = '/?view=trips&sections=' + encodeURIComponent(sectionKey);

        // Indicador de carga opcional
        document.body.setAttribute('data-zd-loading', 'true');

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            document.body.removeAttribute('data-zd-loading');
            var html = data[sectionKey];
            if (!html) {
              console.warn('[ZD] No se encontró la sección:', sectionKey);
              return;
            }
            // Inyectar el HTML al final del body
            var wrapper = document.createElement('div');
            wrapper.innerHTML = html;
            var injected = wrapper.firstElementChild;
            if (injected) {
              document.body.appendChild(injected);
              // Ejecutar scripts inline que pueda traer la sección
              injected.querySelectorAll('script').forEach(function(s) {
                var ns = document.createElement('script');
                ns.textContent = s.textContent;
                document.body.appendChild(ns);
              });
              var panel = document.getElementById(panelId);
              if (panel) _showDetailPanel(panel);
            }
          })
          .catch(function(err) {
            document.body.removeAttribute('data-zd-loading');
            console.error('[ZD] Error cargando detalle del viaje:', err);
          });
      }
    }

    function _showDetailPanel(panel) {
      panel.removeAttribute('hidden');
      if (window.ZDScrollLock) window.ZDScrollLock.lock();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          panel.classList.add('is-open');
        });
      });
    }

    /* =====================================================
       EVENT LISTENERS
       ===================================================== */

    // Interceptar clicks en "#trips-disponibles" (botón hero)
    document.addEventListener('click', function(e) {
      var anchor = e.target.closest('a[href="#trips-disponibles"]');
      if (anchor) {
        e.preventDefault();
        openTripsModal();
        return;
      }

      // Botón de cerrar modal
      if (e.target.closest('#zd-tmodal-close')) {
        closeTripsModal();
        return;
      }

      // Clic en backdrop del modal
      if (e.target.id === 'zd-tmodal-backdrop') {
        closeTripsModal();
        return;
      }

      // Botones / zonas clicables que abren el detalle de un viaje
      var detailTrigger = e.target.closest('[data-open-detail]');
      if (detailTrigger) {
        var slug = detailTrigger.getAttribute('data-open-detail');
        if (slug) {
          e.preventDefault();
          openDetail(slug);
        }
        return;
      }

      // Botón cerrar dentro del panel de detalle
      if (e.target.closest('[data-zd-detail-close]')) {
        var openPanel = document.querySelector('.zd-detail.is-open');
        if (openPanel) {
          openPanel.classList.remove('is-open');
          if (window.ZDScrollLock) window.ZDScrollLock.unlock();
          openPanel.addEventListener('transitionend', function onEnd(e) {
            if (e.target !== openPanel.querySelector('.zd-detail__panel')) return;
            openPanel.setAttribute('hidden', '');
            openPanel.removeEventListener('transitionend', onEnd);
          });
        }
        return;
      }
    });

    // Tecla Escape
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var modal = document.getElementById('zd-trips-modal');
      if (modal && modal.classList.contains('is-open')) {
        closeTripsModal();
        return;
      }
      var openPanel = document.querySelector('.zd-detail.is-open');
      if (openPanel) {
        openPanel.classList.remove('is-open');
        if (window.ZDScrollLock) window.ZDScrollLock.unlock();
        openPanel.addEventListener('transitionend', function onEnd(ev) {
          if (ev.target !== openPanel.querySelector('.zd-detail__panel')) return;
          openPanel.setAttribute('hidden', '');
          openPanel.removeEventListener('transitionend', onEnd);
        });
      }
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
